import React, { Component } from 'react'
import TabView from '../TabView/TabView'
import Tab from '../TabView/Tab'
import StyleMenuRoot from './SidebarStyleMenu/StyleMenuRoot/StyleMenuRoot'
import './SidebarStyleMenu.css'
import '../../components/LanguageSelector/LanguageSelector.css'
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector'

function functionArrowUp() {
	const elementColor=document.querySelector(".theme-option")
	const liElement1 = document.querySelector(".style-menu__option1");
	if (elementColor != null) {
	  liElement1.classList.add("style-menu__option__active");
	};
}

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      elementMenu: props.getSidebarTemplateMenu,
      footer: props.getSideBarFooter,
      currentView: 'elementRoot',
      isFixedScrolling: false,
      currentLangFullName: '',
      hide: false,
      langList: ['Polski', 'English', 'Deutsch', 'Français'],
    }
    this.scrollableRef = React.createRef()
  }

  changeSidebarTemplateMenu = (getSidebarTemplateMenuHandle) => {
    this.setState({ elementMenu: getSidebarTemplateMenuHandle })
  }
  fixScrolling = (val) => this.setState({ isFixedScrolling: val })

  styleMenuCancel = () => {
    if (typeof this.props.onSettingsRevert === 'function') {
      this.props.onSettingsRevert()
    }
    this.onStyleMenuOpenTrigger()
  }

  onStyleMenuOpenTrigger = () => {
    this.setState({ currentView: 'styleRoot' })
    this.props.onStyleMenuOpenTrigger()
  }

  onStyleMenuCloseTrigger = () => {
    this.setState({ currentView: 'elementRoot' })
    this.props.onStyleMenuCloseTrigger()
  }

  changeView = (viewName) => {
    if (this.state.currentView === viewName) {
      this.setState({ currentView: 'styleRoot' });
    } else {
      this.setState({ currentView: viewName });
    }
  }

  TabViewStyleDisplay = () => {
    if (this.state.currentView === 'colorVariables') {
      return { display: 'none' }
    }
  }

  root = () => <React.Fragment></React.Fragment>

  /**
   * @returns {React.StyleHTMLAttributes}
   */

  containerStyle = () => {
    const isRoot = this.state.currentView === 'elementRoot'
    const isFixedScrolling = this.state.isFixedScrolling

    let overflowYValue;
    if (isFixedScrolling && isRoot) {
      overflowYValue = 'scroll';
    } else {
      overflowYValue = 'auto';
    }
    return {
      flexGrow: 1,
      overflowX: 'hidden',
      overflowY: overflowYValue,
    }
  }

  getCurrentTabLabel = () => {
    if (this.state.currentView === 'styleRoot') {
      return 'Tab_Style';
    }
    return null;
  }

  render = () => (
    <div style={this.containerStyle()} ref={this.scrollableRef}   onMouseOver={()=>functionArrowUp()}>
      <TabView
        styleDisplay={this.TabViewStyleDisplay()}
        currentTabLabel={this.getCurrentTabLabel()}
      >
        <Tab label="Tab_Template" onSelect={this.onStyleMenuCloseTrigger}>
          <div className="template-container">
            {this.state.elementMenu?.() }
          
            <LanguageSelector
              langChangeHandler={this.props.onLangChange}
              lang={this.props.currentLang}
            />
          </div>
        </Tab>

        <Tab label="Tab_Style" onSelect={this.onStyleMenuOpenTrigger}>
          <StyleMenuRoot
            {...this.props}
            onSpinnerIconStyleSelect={this.props.onSpinnerIconStyleSelect}
            currentThemeName={this.props.currentThemeName}
            currentViewColor={this.state.currentViewColor}
            onSelectColor={this.props.onSelectColor}
            onSelect={this.changeView}
            onColorSelect={this.props.onColorSelect}
            path={this.state.currentView}
            root={this.root}
            defaultRoute={this.root}
            onBackButtonPress={this.styleMenuCancel}
            onEditClick={() => this.changeView('colorVariables')}
            onColorVariablesBackButtonPress={() => this.changeView('themes')}
            containerRef={this.scrollableRef}
            isSelected={this.isSelected}
          ></StyleMenuRoot>
        </Tab>
      </TabView>   
    </div>
  )

  /**
   * @returns {React.StyleHTMLAttributes}
   */

}
export default Sidebar;